import axios from 'axios';
import { globalURLS } from '../../Global/urls.js';

export const getvideos = async () => {
    const response = await axios.post(`${globalURLS.baseURL}recforge/getvideos`, {}, globalURLS.config);
    return response.data?.data ?? [];
};

export const update_cutouts = async (data) => {
    const response = await axios.post(`${globalURLS.baseURL}recforge/update_cutouts`, data, globalURLS.config);
    return response.data?.success;
};

export const make_video_live = async (data) => {
    const response = await axios.post(`${globalURLS.baseURL}recforge/make_video_live`, data, globalURLS.config);
    return response.data?.success;
};
